export default __webpack_public_path__ + "static/media/GameOver.dc0bfe63.png";